// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase} from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAs1NnbCZ1Y02cQ9XSG1xEEv1PDfvBuod4",
    authDomain: "egpushserver.firebaseapp.com",
    databaseURL: "https://egpushserver-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "egpushserver",
    storageBucket: "egpushserver.appspot.com",
    messagingSenderId: "608158623555",
    appId: "1:608158623555:web:f3ae5628b505935f7431f6",
    measurementId: "G-HTFXKS4TEY"
};
const app = initializeApp(firebaseConfig);
const db = getDatabase();
export {
    app, db
}
